
import { Component, ElementRef, ViewChild } from '@angular/core';
import { PCESClientLists } from '../models/PCES-client-lists.model';
import { NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { map, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { GridApi, IServerSideDatasource, IServerSideGetRowsParams,  ICellRendererParams, ColDef} from 'ag-grid-community';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PcesDetailsComponent } from './pces-client-details/pces-details.component';
import { PCESModalComponent } from './pces-lists-modal/pces-lists-modal.component';
import { PCESClientCreatorComponent } from './pces-client-creator/pces-client-creator.component';

@Component({
  selector: 'app-pces-client-lists',
  templateUrl: './pces-client-lists.component.html',
  styleUrls: ['./pces-client-lists.component.scss']
})

// PCES Client List Component
export class PcesClientListsComponent {

  // Assign Client details component to be the detail cell rendered
  public detailCellRenderer: any = PcesDetailsComponent;  

  rowData: PCESClientLists[] = [];
  
  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;

  constructor(private http: HttpClient, private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private dialog: MatDialog, private zone: NgZone) { }

  search_client: FormGroup = this.fb.group({
    clientname: [''],
    factoringfor: [''],
  })

  private apiUrl = '/api/pces_lists/pces_lists.php';

  // variable to store universal filter 
  universalFilter = ''

  // default column definitions
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  };

  // define headers for the main Client list grid
  columnDefs: ColDef[] = [
    { field: 'client_uuid', headerName: 'UUID', hide: true},
    {
      headerName: 'Client Name',
      field: 'clientname',
      cellStyle: {'font-weight': 'bold'},          
      cellRenderer: 'agGroupCellRenderer',    // Add Drop Down Detail
      width: 400
    },
    {
      headerName: 'Number', field: 'clientnumber',
      width: 200
    },
    {
      headerName: 'Factoring For', field: 'factoringfor',
      width: 250
    },
    { headerName: 'Group Name', field: 'groupname', width: 150 },        
    { headerName: 'Currency', field: 'clientcurrency', width: 125 },      
    {
      headerName: 'Bank No',
      field: 'clientbankno',
      width: 100
    },  
    {
      headerName: 'Branch No',
      field: 'clientbranchno',
      width: 100
    },     
    {
      headerName: 'ABA Routing No',
      field: 'clientabaroutingno',
      width: 150
    },             
    {
      headerName: 'Account No',
      field: 'clientaccountno',
      width: 150
    },            
    {
      headerName: 'Entry Description',
      field: 'cliententrydescription',
      width: 150
    },    
    {
      headerName: 'Transaction Code',
      field: 'clienttransactioncode',
      width: 150
    },          
    {
      headerName: 'Address',
      field: 'clientaddress',
      width: 150
    },    
    {
      headerName: 'City',
      field: 'client_locality',
      width: 150
    },    
    {
      headerName: 'Province/State',
      field: 'client_region',
      width: 150
    },        
    {
      headerName: 'Postal Code',
      field: 'client_postal_code',
      width: 150
    },     
    {
      headerName: 'Country',
      field: 'client_country',
      width: 150
    },       
    {
      headerName: 'Action', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deleteClient(params);
          });
        });
        return button;
      }, editable: false, width: 100,
    },                        
  ]

  //Apply filter dynmically
  ngAfterViewInit() {
    console.log('ngAfterViewInit:')
    if (this.agGrid) {
      this.route.queryParamMap.subscribe((params) => {
        const clientname = params.get('clientname');
        const factoringfor = params.get('factoringfor');
        
        if (clientname) {
          this.applyClientName(clientname);
          console.log('clientname:',clientname)
        }
        else if (factoringfor) {
          this.applyFactoringFor(factoringfor);
          console.log('factoringfor:',factoringfor)
        }
        else {
          this.agGrid.api.setFilterModel({});
        }
      });
    }
  }


  //Apply filter for ClientName
  applyClientName(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        clientname: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  //Apply filter for Factoring For
  applyFactoringFor(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        factoringfor: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  search() {
    const clientname = this.search_client.get('clientname')?.value
    const factoringfor = this.search_client.get('factoringfor')?.value
    if (clientname) {
      this.router.navigate(['/pces_client_lists'], { queryParams: { clientname: clientname } });
    }
    else if (factoringfor) {
      this.router.navigate(['/pces_client_lists'], { queryParams: { factoringfor: factoringfor } });
    }
    else {
      console.log('Invalid search data.')
    }    
  }

  //Reset the filter by setting to empty object
  resetFilter() {
    this.router.navigate(['/pces_client_lists']);
    this.search_client.get('clientname')?.setValue('');
    this.search_client.get('factoringfor')?.setValue('');
  }  

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api
    params.api.setServerSideDatasource(this.getServerSideDatasource());
    this.gridApi = params.api; 
    // // Resize columns to fit the grid width
    this.gridApi?.addEventListener('firstDataRendered', () => {
      this.autoSizeAll(false);
    });    
  }

  autoSizeAll(skipHeader: boolean) {
    const allColumnIds: string[] = [];
    this.gridApi.getColumns()!.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    this.gridApi.autoSizeColumns(allColumnIds, skipHeader);
  }
  
  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getPcesList(params.request.startRow, params.request.endRow, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              if (response) {
                console.log(response);
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  getPcesList(startRow: number = 0, endRow: number = 0, filterModel: any = {}, sortModel: any = []) {
    const urlApi = this.apiUrl;

    const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
      console.log('Filter model:', filterModel);
      console.log('Filter', filter)

      let operator = '';
      let value = '';

      if (filter.filterType === 'text') {
        operator = filter.type;
        value = filter.filter;
      } else if (filter.filterType === 'set') {
        operator = 'equals'; // Or any other appropriate operator for set filter
        value = filter.values.join(','); // Join selected values with a delimiter if needed
      }

      return {
        column,
        operator,
        value,
      };
    });

    const params: any = {
      startRow: startRow,
      endRow: endRow,
      sortModel: JSON.stringify(sortModel),
      filters: JSON.stringify(filters),
    };

    console.log('an array of filter object: ', filters)
    const url = `${urlApi}?startRow=${startRow}&endRow=${endRow}&universalFilter=${this.universalFilter}`;

    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        return {
          rowData: response.data,
          rowCount: response.total,
        };
      }),
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
      filter(response => response !== null)
    );

  }  

  createPCESClient() {
    const dialogRef: MatDialogRef<PCESClientCreatorComponent> = this.dialog.open(PCESClientCreatorComponent, {
      width: '50%',
      height: '50%',
      data: { }
    });

    // Subscribe to the afterClosed event to handle any actions after the modal is closed
    dialogRef.afterClosed().subscribe((result) => {

    });
  }
  
  deleteClient(params: any) {
    const dialogConfig = new MatDialogConfig();
    const client_uuid = params.data.client_uuid;
    const clientname = params.data.clientname;

    dialogConfig.width = '10'; // You can use pixels or other units
    dialogConfig.height = '10';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Client Information',
        modalMessage: {uuid: params.data.client_uuid, client_name: params.data.clientname},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }

 
  uploadTransaction() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '555px'; // You can use pixels or other units
    dialogConfig.height = '200px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Upload Transaction File',
        modalMessage: '',
      },
    };
    this.dialog.open(PCESModalComponent, dialogConfig);
  }
  
  pcesEmailLists() {
    this.router.navigate(['/pces_email_lists']);
  }

  pcesTransactionPendingLists() {
    this.router.navigate(['/pces_transaction_pending_lists']);
  }
}


